import { connect } from 'react-redux'
import ProviderProductActivateModal from '../../components/products/ProviderProductActivateModal'
import * as productActions from '../../state/actions/provider-products/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const product = state.providerProduct.activateProductModal.product
  return {
    product,
    activating: state.providerProduct.activateProductModal.activating,
    error: state.providerProduct.activateProductModal.error
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCancelClick: () => {
      dispatch(productActions.actionCreators.productActivateModalHide())
    },
    onActivateClick: (productId: string) => {
      dispatch(productActions.activateProduct(productId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductActivateModal)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductActivateModal.ts